function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/client/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const RClient = [
  {
    path: '/client/dashboard',
    component: view('Dashboard'),
    name: 'client.dashboard'
  }
]

const RClientAccounts = [
  {
    path: '/client/accounts/users',
    component: view('accounts/Users'),
    name: 'client.accounts.users',
    meta: {
      breadcrumb: [
        {
          text: 'Client'
        },
        {
          text: 'Accounts'
        },
        {
          text: 'Users',
          active: true
        }
      ]
    }
  }
]

const RClientServices = [
  {
    path: '/client/services/cards',
    component: view('services/Cards'),
    name: 'client.services.cards',
    meta: {
      breadcrumb: [
        {
          text: 'Client'
        },
        {
          text: 'Services'
        },
        {
          text: 'Cards',
          active: true
        }
      ]
    }
  },
  {
    path: '/client/services/card/:card?',
    component: view('services/card-manager/Base'),
    name: 'client.services.card-management',
    meta: {
      breadcrumb: [
        {
          text: 'Client'
        },
        {
          text: 'Services'
        },
        {
          text: 'Card',
          active: true
        }
      ]
    }
  }
]

export default RClient.concat(
  RClientAccounts,
  RClientServices
)
